import "core-js/modules/es.string.replace.js";

/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */
document.addEventListener('DOMContentLoaded', () => {
  $('.header__menu ul li a, .footer__menu ul li a').click(function (event) {
    $('html').removeClass('is-menu-open');

    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      let target = $(this.hash);
      target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);

      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 105
        }, 750);
      }
    }
  });
  $(window).scroll(function () {
    if ($(this).scrollTop() > 20) {
      $('.header').addClass('header--fixed');
    } else {
      $('.header').removeClass('header--fixed');
    }
  });
  $('.js-toggle-menu').click(function (e) {
    e.preventDefault();
    $('html').toggleClass('is-menu-open');
  });
  $('.pricing__slide-link').click(function (e) {
    e.preventDefault();
  });
  $('.js-price-item').click(function () {
    var tab_id = $(this).attr('data-tab');
    $('.js-price-item').removeClass('is-active');
    $('.js-price-content').removeClass('is-active');
    $('.pricing__step1').addClass('is-active');
    $(this).addClass('is-active');
    $("#" + tab_id).addClass('is-active');
    $('.pricing-slider').slick('setPosition');
  });
  $('.is-back').click(function (e) {
    e.preventDefault();
    $('.pricing__step1').removeClass('is-active');
    $('.pricing__step2').removeClass('is-active');
    $('.pricing-slider').slick('setPosition');
  });
  $('.tab').on('click', function (evt) {
    evt.preventDefault();
    $('.tab.is-active').removeClass('is-active');
    $(this).addClass('is-active');
    let sel = this.getAttribute('data-toggle-target');
    $('.tab-content').removeClass('is-active').filter(sel).addClass('is-active');
  });
  $('.pricing__slide:nth-child(1)').on('click', function (evt) {
    evt.preventDefault();
    $(this).toggleClass('is-active');
    $('.pricing__step2').toggleClass('is-active1');
  });
  $('.pricing__slide:nth-child(2)').on('click', function (evt) {
    evt.preventDefault();
    $(this).toggleClass('is-active');
    $('.pricing__step2').toggleClass('is-active2');
  });
  $('.pricing__slide:nth-child(3)').on('click', function (evt) {
    evt.preventDefault();
    $(this).toggleClass('is-active');
    $('.pricing__step2').toggleClass('is-active3');
  });
});